export function chunk<T>(array: Array<T>, chunkSize: number): Array<Array<T>> {
	const chunkedArray: Array<Array<T>> = [];
	let index = 0;

	while (index < array.length) {
		chunkedArray.push(array.slice(index, index + chunkSize));
		index += chunkSize;
	}

	return chunkedArray;
}
